/* tslint:disable */
/* eslint-disable */
/**
 * Probonio full API Docs
 * If you stumbled upon this page and want to integrate Probonio into your business software [click here!](/api/external)    If you\'re looking for more information about Probonio [head over here](https://probonio.de)    **This documentation describes all Endpoints of the Probonio API. It\'s created for experienced Probonio Developers only!**   <a href=\"http://localhost:4100/mock-idp/realms/probonio/protocol/openid-connect/logout\" target=\"_blank\"><button>     <h4>Click here to trigger a full logout from Keycloak.</h4> </button></a><br /> 
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface BikeleasingContractListItemDTO
 */
export interface BikeleasingContractListItemDTO {
    /**
     * 
     * @type {string}
     * @memberof BikeleasingContractListItemDTO
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof BikeleasingContractListItemDTO
     */
    'status'?: BikeleasingContractListItemDTOStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof BikeleasingContractListItemDTO
     */
    'contractNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof BikeleasingContractListItemDTO
     */
    'probonioEmployeeId'?: string;
    /**
     * 
     * @type {string}
     * @memberof BikeleasingContractListItemDTO
     */
    'bikeBrand'?: string;
    /**
     * 
     * @type {string}
     * @memberof BikeleasingContractListItemDTO
     */
    'firstName'?: string;
    /**
     * 
     * @type {string}
     * @memberof BikeleasingContractListItemDTO
     */
    'lastName'?: string;
    /**
     * 
     * @type {string}
     * @memberof BikeleasingContractListItemDTO
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof BikeleasingContractListItemDTO
     */
    'startDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof BikeleasingContractListItemDTO
     */
    'endDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof BikeleasingContractListItemDTO
     */
    'applicationDate'?: string;
    /**
     * 
     * @type {number}
     * @memberof BikeleasingContractListItemDTO
     */
    'monthlyPayment'?: number;
}

export const BikeleasingContractListItemDTOStatusEnum = {
    EmployeeApprovalRequired: 'EMPLOYEE_APPROVAL_REQUIRED',
    EmployerApprovalRequired: 'EMPLOYER_APPROVAL_REQUIRED',
    CancelledOrRejected: 'CANCELLED_OR_REJECTED',
    EmployerApprovalDone: 'EMPLOYER_APPROVAL_DONE',
    BikeTransferRequired: 'BIKE_TRANSFER_REQUIRED',
    BikeTransferDone: 'BIKE_TRANSFER_DONE',
    Active: 'ACTIVE',
    Expiring: 'EXPIRING',
    Finished: 'FINISHED',
    Requested: 'REQUESTED',
    BikeShipped: 'BIKE_SHIPPED'
} as const;

export type BikeleasingContractListItemDTOStatusEnum = typeof BikeleasingContractListItemDTOStatusEnum[keyof typeof BikeleasingContractListItemDTOStatusEnum];


